import { io } from "socket.io-client";

export const {
  ENV_API_BASE_URL
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
} = dmenv;

export const socket = io(ENV_API_BASE_URL, {
  autoConnect: true,
  transports: ["websocket"]
});
